import cx from "classnames";
import { CustomDatoImage } from "components/CustomDatoImage/CustomDatoImage";
import { CheckIconSvg } from "components/icons/CheckIconSvg";
import { FC, SVGProps } from "react";
import { ProductBySlugQuery } from "services/datocms/generated";
import { colors } from "styles/variables";
import st from "./CylinderType.module.scss";

export type DatoCylinderType = NonNullable<
  ProductBySlugQuery["product"]
>["cylinderTypes"][number];

interface CylinderTypeProps {
  cylinderType: DatoCylinderType;
  isSelected: boolean;
  setSelectedCylinderType: (cylinderType: DatoCylinderType) => void;
  index: number;
}

export const CylinderType: FC<CylinderTypeProps> = ({
  cylinderType,
  isSelected,
  setSelectedCylinderType,
}: CylinderTypeProps) => {
  return (
    <div
      className={cx(st.cylinderType, isSelected && st.selected)}
      onClick={() => setSelectedCylinderType(cylinderType)}
      bi-type="Co2 Cylinder - Select a cylinder"
      bi-id={cylinderType.title}
    >
      <div className={st.image}>
        {cylinderType.image?.responsiveImage && (
          <CustomDatoImage
            layout="fill"
            data={cylinderType.image?.responsiveImage}
            width={50}
          />
        )}
      </div>
      <span>{cylinderType.title}</span>
      <div className={st.selectedIcon}>
        <CornerTriangle className={st.leftTopCorner} />
        <CheckIconSvg />
        <CornerTriangle className={st.bottomRightCorner} />
      </div>
    </div>
  );
};

const CornerTriangle: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 9.53674e-07L1.17622e-06 2.54292e-07C4.41828 6.4055e-07 8 3.58172 8 8L8 9.53674e-07Z"
        fill={colors.primaryFreshBlue}
      />
    </svg>
  );
};
